export enum SOURCING_SETTINGS_TABS {
  JOB_APPLICATION_STAGES = 'jobApplicationStages',
  INTERVIEWERS = 'interviewers',
  SUPPLIER_GROUPS = 'supplier-groups',
  SENIORITY = 'seniority'
}
